import React from 'react';
import { Box, Typography, Divider, FormControl, TextField, FormHelperText } from '@material-ui/core';
import { useStyles } from './styles.esm.js';
import { Autocomplete } from '@material-ui/lab';
import { SkeletonComponent } from './skeletonComponent.esm.js';
export { OptionsPickerSchema } from './schema.esm.js';

const OptionsPicker = (props) => {
  const [propertySelected, setPropertySelected] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const { uiSchema, schema, onChange, formData, required, rawErrors, idSchema, formContext } = props;
  const [optionsState, setOptionsState] = React.useState([]);
  const [key, property] = resolveUiSchema(uiSchema);
  const { autocompleteWrapper, descriptionContent, boxInfo } = useStyles();
  const items = optionsState ? optionsState.map((i) => ({ label: i, value: i })) : [{ label: "Loading...", value: "loading" }];
  const onSelect = React.useCallback(
    (_, ref, reason) => {
      if (typeof ref === "string" && ref) {
        onChange(ref);
      } else {
        if (reason === "blur" || reason === "create-option") {
          let entityRef = ref;
          try {
            entityRef = JSON.stringify(entityRef);
          } catch (err) {
          }
          if (formData !== entityRef) {
            onChange(entityRef);
          }
        }
      }
    },
    [onChange, formData]
  );
  React.useEffect(() => {
    if (key && property) {
      setLoading(true);
      const context = formContext;
      const options = context.formData[key][property];
      if (options) {
        options.map((option) => setOptionsState((prevState) => [...prevState, option]));
      }
      setTimeout(() => {
        setLoading(false);
      }, 1e3);
    }
  }, [key, property]);
  React.useEffect(() => {
    if (formData) {
      setPropertySelected(formData);
    }
  }, [onChange, formData]);
  if (loading) return /* @__PURE__ */ React.createElement(
    SkeletonComponent,
    {
      title: schema.title ?? "Options Picker",
      description: schema.description ?? "Choose an option from a result coming from the selected resourcePicker"
    }
  );
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Box, { my: 1 }, /* @__PURE__ */ React.createElement(Typography, { variant: "h5" }, schema.title ?? "Options Picker"), /* @__PURE__ */ React.createElement(Divider, null)), /* @__PURE__ */ React.createElement(Box, { className: descriptionContent }, /* @__PURE__ */ React.createElement(Typography, { variant: "body1" }, schema.description ?? "Choose an option from a result coming from the selected resourcePicker")), /* @__PURE__ */ React.createElement(React.Fragment, null, optionsState.length > 0 ? /* @__PURE__ */ React.createElement(
    FormControl,
    {
      margin: "normal",
      required,
      error: rawErrors?.length > 0 && !formData
    },
    /* @__PURE__ */ React.createElement(
      Autocomplete,
      {
        disabled: items.length === 1,
        className: autocompleteWrapper,
        id: idSchema?.$id,
        value: propertySelected ? propertySelected : optionsState[0],
        loading,
        onChange: onSelect,
        options: optionsState || [],
        getOptionLabel: (option) => option,
        renderInput: (params) => /* @__PURE__ */ React.createElement(
          TextField,
          {
            ...params,
            label: "Select the option...",
            variant: "outlined",
            margin: "dense",
            FormHelperTextProps: {
              margin: "dense",
              style: { marginLeft: 0 }
            },
            InputProps: params.InputProps
          }
        )
      }
    ),
    /* @__PURE__ */ React.createElement(FormHelperText, null, "Select the desired option")
  ) : /* @__PURE__ */ React.createElement(Box, { className: boxInfo }, "\u26A0\uFE0F No options available")));
};
function resolveUiSchema(uiSchema) {
  const key = uiSchema["ui:options"]?.key;
  const property = uiSchema["ui:options"]?.property;
  return [key, property];
}

export { OptionsPicker, resolveUiSchema };
//# sourceMappingURL=OptionsPicker.esm.js.map
